export const parsePubchemResponse = text => {
  const lines = text.split('\n');
  let lineNum = 0;
  const dict = {};

  while (lineNum < lines.length) {
    let line = lines[lineNum];
    lineNum += 1;
    if (line.indexOf('> <') !== 0) {
      continue;
    }

    const entryLines = [];
    dict[line.substr(3, line.length - 4)] = entryLines;
    line = lines[lineNum];
    while (line !== '') {
      entryLines.push(line);
      lineNum += 1;
      line = lines[lineNum];
    }
  }

  return dict;
};
